<template lang="pug">
	dx-validation-group.web-service--parent-service-param.flex-1
		.flex-col.space-large
			.web-service-param-button.flex-row.space.align-center.justify(@click="showPopup()")
				.flex-row.space-small(:class="{ grey: !selectedResult }") {{selectedDisplayValue}}
				.select-action(@click="showPopup")
					fas(v-if="parentService", icon="magnifying-glass")
					fas(v-else, icon="spinner", :spin="true")
		Popup(v-if="popupVisible", :popupVisible="popupVisible", :width="580", :height="500", :closeOnOutsideClick="false", :title="name", :showMaximize="true", @resize="onPopupResize")
			.flex-col.space.web-service--parent-service-param(:class="{ 'param-is-array': paramIsArray }")
				template(v-if="selectionOutputsVisible")
					ListView.no-padding(ref="listView", v-if="output && output.length", :getData="getItems", :getTotal="r => r.total", :valueExpr="keyField", :height="gridHeight", :getItems="r => r.items", initialView="table", :remoteGrouping="false", 
						:hideViewsSelection="true", :columns="listViewColumns", :showColumnHeaders="paramIsArray", :selectionMode="paramIsArray ? 'single' : 'none'" :topPagerVisible="false", :refreshVisible="false", :searchVisible="!paramIsArray", 
						:columnHidingEnabled="false", @selection="v => onSelectResult(v ? v[0] : null)", :remoteSorting="false", :remotePaging="false", :bottomPagerVisible="false", :headerFilter="paramIsArray", :filterRow="paramIsArray",
						:remoteFiltering="false")
						template(v-slot:outputTemplate="{ data }")
							.output-item.flex-row.justify.align-center(@click="onSelectResult(data)")
								.wrap {{data[displayField] || data[keyField]}}
								fas(icon="arrow-right")
				.structure(v-else-if="!forceOutputsSelection" :class="{ 'disabled-controls': paramOutputProcessing }")
					structure-criteria(ref="criteria", :service="parentService", :hideCriteria="true", :hideHeaders="true", :params="parentParams", :paramsCaptions="parentParamsCaptions", :propagatedEditableParamsList="propagatedEditableParams")
				slot
				Loader(v-if="paramOutputProcessing", :fullscreen="true")
			template(slot="actions-left")
				DxButton(v-if="serviceOutput && !forceOutputsSelection", :text="$tCaption('Back', '@actions')", type="default", @click="serviceOutput = null")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false")
				DxButton(v-if="!serviceOutput", :text="$tCaption('Next', '@actions')", type="default", @click="processParamOutput", :disabled="paramOutputProcessing")
</template>

<script>
	import _ from 'lodash';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxTextBox from 'devextreme-vue/text-box';
	import ScrollView from 'devextreme-vue/scroll-view';
	import ListView from 'app-core/ListView.vue';

	export default {
		translationCategory: 'webServiceCaller.StructureCriteria',
		name: 'web-service--parent-service-param',
		components: { Popup, DxButton, Loader, DxValidationGroup, DxTextBox, ScrollView, ListView },
		model: {
		},
		props: ['serviceId', 'name', 'serviceOutputName', 'value', 'caption', 'forceOutputsSelection', 'params', 'paramsCaptions'],
		data() {
			return {
				parentService: null,
				parentParams: null,
				parentParamsCaptions: null,
				popupVisible: false,
				paramOutputProcessing: false,
				serviceOutput: null,
				selectedResult: this.value ? this.getSelectedValue() : null,
				outputFilter: null,
				propagatedEditableParams: {},
				columns: [
					{ dataField: 'output', cellTemplate: 'outputTemplate' },
				],
				gridHeight: 320
			};
		},		
		computed: {
			filteredOutput() {
				return (this.serviceOutput && this.serviceOutput[this.serviceOutputName] || []).filter(f => !this.outputFilter || `${f[this.displayField]}`.toLowerCase().indexOf(this.outputFilter.toLowerCase()) > -1);	
			},
			output() {
				return this.serviceOutput && _.orderBy(this.filteredOutput, [this.displayField, this.keyField]) || null;
			},
			selectedDisplayValue() {
				return (this.selectedResult && (this.selectedResult?.Value|| this.selectedResult?.Key)) || this.name;
			},
			selectionOutputsVisible() {
				return this.output && Array.isArray(this.output);
			},
			param() {
				return this.parentService?.JsonDefinition?.Outputs?.find(f => f.Name === this.serviceOutputName);
			},
			listViewColumns() {
				return !this.paramIsArray ? 
					this.columns : 
					this.param.ArrayFields
						.filter(f => f.visible !== false)
						.map(f => ({ dataField: f.id, caption: f.caption || this.$Data.idToReadable(f.id), dataType: f.dataType }));
			},
			paramIsArray() {
				return !!this.param?.IsArray;
			},
			keyField() {
				return this.paramIsArray && this.param?.ArrayFields?.some(f => f.id === this.param?.KeyField) && this.param?.KeyField || 'Key';
			},
			displayField() {
				return this.paramIsArray && this.param?.ArrayFields?.some(f => f.id === this.param?.DisplayField) && this.param?.DisplayField || 'Value';
			},
			visibleColumnsIds() {
				return this.paramIsArray && this.param.ArrayFields.filter(f => f.visible !== false).map(f => f.id) || [this.displayField];
			}
		},
		watch: {
			selectedResult: {
				handler(v) {
					const params = {};
					const paramsCaptions = {};
					if (this.parentParams) {
						this.parentService.JsonDefinition.Parameters.map(p => {
							params[p.Name] = this.parentParams[p.Name];
							paramsCaptions[p.Name] = this.parentParamsCaptions[p.Name];
							if (p.UserEditable)
								this.propagatedEditableParams[p.Name] = true;
						});
						if (__DEBUG__)
							console.debug('Selected result changed', { v, params });
						this.$emit('change', v?.Key, v, params, paramsCaptions, this.propagatedEditableParams);
					}
				},
				deep: true
			},
			value(v) {
				if (v && this.selectedResult?.Key !== v) {
					this.selectedResult = this.getSelectedValue();
				} else {
					if (!v && this.selectedResult?.Key !== v) {
						this.selectedResult = null;
					}
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.parentServiceParam = this;

			this.$Data.getExternalServices(0, 1, { byKey: this.serviceId }).then(r => {
				this.parentService = r.Results[0];
			});
		},		
		destroyed() {
		},
		methods: {
			onPopupResize(width, height) {
				if (__DEBUG__)
					console.debug('onPopupResize', { width, height });
				this.gridHeight = Math.max(220, height - 55);
				if (this.$refs.listView) {
					this.$nextTick(() => {
						this.$refs.listView.gridWidth = width - 10;
					});
				}
			},
			getSelectedValue() {
				const res = { Key: this.value, Value: this.caption || this.value };
				res[this.displayField] = this.caption || this.value;
				res[this.keyField] = this.value;
				return res;
			},
			getItems(page, limit, opts) {
				if (opts?.byKey)
					return this.output.find(f => f.Key === opts.byKey);
				const items = (this.output || []).filter(f => !opts?.filter?.filterValue || this.visibleColumnsIds.some(k => `${f[k]}`.toLowerCase().indexOf(opts.filter?.filterValue.toLowerCase()) > -1));
				if (__DEBUG__)
					console.debug('getItems', { page, limit, opts, items });
				return {
					total: items.length,
					items: items
				};
			},
			onSelectResult(out) {
				if (out) {
					out.Key = out[this.keyField];
					out.Value = out[this.displayField];
				}

				this.selectedResult = out;
				this.popupVisible = false;
			},
			processParamOutput(e) {
				if (__DEBUG__)
					window.parentServiceParam = this;
				if (e?.validationGroup && !e.validationGroup.validate().isValid) {
					return;
				}
				this.paramOutputProcessing = true;
				const params = this.parentParams = this.$refs.criteria?.paramValues || this.params || {};
				this.parentParamsCaptions = this.$refs.criteria?.paramCaptions|| this.paramsCaptions || {};
				this.serviceOutput = [];
				this.$Data.postExternalApi('ExternalService/RunExternalService', {
					ExternalServiceOid: this.parentService.Oid,
					FormatResponse: !!this.parentService.JsonDefinition.Outputs.length,
					Parameters: Object.keys(params).map(f => ({ Name: f, Value: params[f] }))
				}).then(r => {
					if (__DEBUG__)
						console.debug('RunExternalService', { r });
					if (r.Success) {
						if (this.parentService.JsonDefinition.Outputs.length)
							this.serviceOutput = r.Data.FormattedResponse && JSON.parse(r.Data.FormattedResponse);
						if (!Array.isArray(this.output)) {
							this.onSelectResult(this.output);
						}
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				}).finally(() => this.paramOutputProcessing = false);
			},
			showPopup() {
				if (!this.parentService) return;
				if (__DEBUG__)
					window.parentServiceParam = this;
				this.popupVisible = false;
				this.paramOutputProcessing = false;
				setImmediate(() => {
					this.popupVisible = true;
					this.checkAutoNext();
				});
			},
			checkAutoNext() {
				setImmediate(() => {
					if (this.forceOutputsSelection) {
						this.processParamOutput();
						return;
					}
					if (this.popupVisible && this.parentService) {
						if (!this.parentService.JsonDefinition?.Parameters?.some(f => f.UserEditable)) {
							this.processParamOutput();
						}
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.web-service--parent-service-param {
		.dx-datagrid .dx-editor-with-menu, .dx-datagrid-container .dx-editor-with-menu {
			height: 28px !important;
		}

		.dx-editor-cell .dx-texteditor .dx-texteditor-input {
			height: 28px !important;
			line-height: 28px !important;
		}

		.dx-datagrid .dx-menu .dx-menu-item .dx-menu-item-content, .dx-datagrid-container .dx-menu .dx-menu-item .dx-menu-item-content {
			padding: 0px !important;
		}

		td {
			padding: 0px !important;
		}

		&.param-is-array {
			td {
				padding: 4px !important;
			}
		}
		
		.output-item {
			padding: 10px;
			background: rgba(0,0,0,0.05);
			margin-bottom: 2px;
			transition: 0.3s;
			cursor: pointer;

			&:hover {
				background: $base-accent;
				color: $base-bg;
			}
		}

		.dx-datagrid-rowsview .dx-datagrid-content tbody tr.dx-data-row.dx-row-lines:hover {
			background: $base-accent;
			color: $base-bg;
		}
	}
</style>
